import calculateCurrentMinute from './utils/calculateCurrentMinute';
import logAverageFpsPerMinute from './logAverageFpsPerMinute';
import requestAnimFrameWrapper from './utils/requestAnimFrameWrapper';
import {
    addFrameEndTime,
    getFirstFrameEndTime,
    getFrameEndTimes,
    flushFrameEndTimes,
} from './models/frameEndTimes';
import { addMinuteInfo, flushMinuteInfo, getMinuteInfo } from './models/minuteInfo';
import { isDocumentVisible } from 'owa-analytics/lib/utils/visibilityState';
import { lazyJankLogger } from 'owa-fps-jank';
import { Config } from 'owa-fps-types';
import { msInMinute } from 'owa-fps/lib/const';

export default function trackFps(config?: Config) {
    const trackFpsCallback = (hiResTimestamp: DOMHighResTimeStamp) => {
        // Every minute, calculate a new MinuteInfo
        const firstFrame = getFirstFrameEndTime();
        if (firstFrame && firstFrame.time < hiResTimestamp - msInMinute) {
            calculateCurrentMinute(getFrameEndTimes(), addMinuteInfo);
            flushFrameEndTimes();
        }

        // Every five minutes, log a datapoint and flush the MinuteInfo buffer
        const minuteInfo = getMinuteInfo();
        if (minuteInfo.length >= 5) {
            logAverageFpsPerMinute(minuteInfo.buffer, config && config.sampleRate);
            flushMinuteInfo();
        }

        // Every frame, calculate frame info
        const newFrameEndTime = addFrameEndTime(hiResTimestamp, !isDocumentVisible());

        if (config && config.jankOptions) {
            const { jankOptions } = config;
            lazyJankLogger
                .import()
                .then(logger => logger.logJank(hiResTimestamp, newFrameEndTime, jankOptions));
        }

        // call the callback, passing trackFps so that it can be called
        // afterwards. This allows us to insert a stub callback for testing
        // purposes.
        requestAnimFrameWrapper(trackFpsCallback);
    };

    // Call the callback once to get things rolling.
    requestAnimFrameWrapper(trackFpsCallback);
}
